import * as actionTypes from '../constants/ActionTypes/MyPlan';

const initialState = {
    success:false,
    plans: {},
    loading: false,
    error: null,
  }

const GetBenefitOfSupplies = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.GET_BENEFIT_OF_SUPPLIES:
            return {
                ...state,
                loading: true
            }
        
        case actionTypes.GET_BENEFIT_OF_SUPPLIES_SUCCESS:
            return {
                ...state,
                success:true,
                plans: action.plans,
                loading: false
            }
        
        case actionTypes.GET_BENEFIT_OF_SUPPLIES_ERROR:
            return {
                ...state,
                success:false,
                loading: false,
                error: action.message
            }
        default:
            return {...state}
    }
}

export default GetBenefitOfSupplies